import { render, staticRenderFns } from "./BalancesTransactions.vue?vue&type=template&id=6ca65638&"
import script from "./BalancesTransactions.vue?vue&type=script&lang=ts&"
export * from "./BalancesTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports